
import Vue from "vue";
import RULES from "@/mixins/rules";
import { mapGetters } from "vuex";
import RequestFormGral from "../RequestFormGral.vue";
import LicenciaService from "@/services/LicenciaService";
import EstablecimientoService from "@/services/EstablecimientoService";
import CatastroService from "@/services/CatastroService";

export default Vue.extend({
  name: "RenovarEstablecimiento",
  props: {
      idSolicitud: String,
      anio: Number,
      value: Object,
    },
  mixins: [RULES],
  components: { RequestFormGral },
  directives: {},
  computed: {
    ...mapGetters({
      usuario: "usuario",
      id: "id",
      contribuyente: "contribuyente",
      mini: "sidebar",
    }),
  },
  data: () => ({
    anioActual: new Date().getFullYear(),
    tipo_proceso: "0",
    establecimiento: "0",
    guardar: false,
    actualizar: false,
    enviado_revision: false,
    creado: false,
    id_creado: 0,
    disabled: false,
    canSubirLicencia: false,
    licenciaId: 0,
    disabledEnviar: false,
    estatusUsoSuelo: 0,
    claveCatastro: "",
    dialogPredial: false,
  }),
  mounted() {
      console.log("mounted index", this.idSolicitud);
      this.establecimiento = this.idSolicitud;
  },
  methods: {
    pagarPredialLinea(){
      window.open('https://predial.opb.gob.mx/predial', '_blank')
    },
    async submitForm(payload: any){
      this.guardar = false;
      this.actualizar = false;
      //console.log("submitform update", payload);
      if (payload.success) {
        this.creado = true;
        this.id_creado = payload.location.id;
        
        if(payload.location.licencia.length){
          this.claveCatastro = payload.location.clave_catastral;
          this.disabledEnviar = false;
          //this.licenciaId = payload.location.licencia[0].id;
          //console.log("constancia_uso_suelo", payload.location?.constancia_uso_suelo);
          //if (payload.location.licencia[0].estatus_licencia == 10 || payload.location.licencia[0].estatus_licencia == 3 || payload.location.licencia[0].estatus_licencia == 4) {
          //  this.enviado_revision = true;
          //  this.disabled = true;
          //}
          
          if (payload.location?.constancia_uso_suelo[0]?.estatus_general){
            this.estatusUsoSuelo = payload.location?.constancia_uso_suelo[0]?.estatus_general;
            if (this.estatusUsoSuelo == 5) {
              this.disabled = false;
            }
          }
          //console.log("estatusUsoSuelo", this.estatusUsoSuelo);
        }else{
          this.disabledEnviar = true;
        }
        this.canSubirLicenciaBebidas(payload);
      }

      //obtener estatus licencia del año
      LicenciaService.getLicenciaEstatus(this.idSolicitud, this.anio).then((response) => {
        this.licenciaId = response.data.id;
        //console.log("estatus licencia", response.data);
        this.enviado_revision = false;
        this.disabled = false;
        if (response.data.estatus_licencia == 10 || response.data.estatus_licencia == 3 || response.data.estatus_licencia == 4) {
          this.enviado_revision = true;
          this.disabled = true;
        }
      });
      //console.log("estatusUsoSuelo", this.estatusUsoSuelo);
    },
    async enviarRevision(){
      //Revisar si ya pagó predial
      //let {data: {resultados: catastro}} = await CatastroService.searchByClaveCatastral(this.claveCatastro);

      if(this.claveCatastro != "DONATIVO" && this.claveCatastro != "MERCADO" && this.claveCatastro != "ZONA FEDERAL"){
        let { data } = await EstablecimientoService.getPagoPredial(this.claveCatastro);

        if (data.data) {
          this.$toast.success(data.message);
          //return;
        } else {
          this.$toast.error(data.message)
          this.dialogPredial = true;
          return;
        }
      }else{
      }

      //return;

      const object = {
        'estatus_licencia': 10,
      }
      //@ts-ignore
      this.$refs.requestFormGral.handleForValidate().then(async (response) => {
        if (response) {
          //@ts-ignore
          this.$refs.requestFormGral.handleFormSubmit();
          let { data } = await LicenciaService.newYear(this.idSolicitud, this.anio, object);
          if (data.success) {
            this.enviado_revision = true;
            this.disabled = true;
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message)
          }
        }
      })
      //return;
      //@ts-ignore
      //this.$refs.requestFormGral.handleFormSubmit();
      //Check if renovacion is 1 or true send to new service enviarRevision on RenovacionController
      
    },
    async enviarRevisionUsoSuelo(){
      const object = {
        'estatus_general': 1,
      }
      //@ts-ignore
      this.$refs.requestFormGral.handleFormSubmit();
      //Check if renovacion is 1 or true send to new service enviarRevision on RenovacionController
      let { data } = await LicenciaService.changeEstatusUsoSuelo(this.licenciaId, object);
      if (data.success) {
        this.estatusUsoSuelo = 1;
        this.$toast.success(data.message);
      } else {
        this.$toast.error(data.message)
      }
    },
    canSubirLicenciaBebidas(payload: any) {
      const pago = payload.location.archivos.find((archivo: any) => archivo.archivo.tipo_archivo == "pago_licencia_bebidas");
      if (!pago) {
        this.canSubirLicencia = false;
      }else{
        let date = new Date(pago.archivo.created_at);
        date.setMonth(date.getMonth() + 2);
        let fechaActual = new Date();
        if (date >= fechaActual) {
          this.canSubirLicencia = false;
        } else {
          this.canSubirLicencia = true;
        }
      }
      
      console.log('canSubirLicenciaBebidas', pago);
      console.log('canSubirLicenciaBebidas', this.canSubirLicencia);
      
    }
  }
});
